import React, { createContext, useContext, useState } from 'react';

const translations = {
  fr: {
    // Navbar
    nav_features: "Fonctionnalités",
    nav_pricing: "Tarifs",
    nav_advantages: "Avantages",
    nav_logitrak: "Logitrak",
    nav_contact: "Contact",
    nav_login: "Connexion",
    
    // Hero
    hero_badge: "Gestion de flotte simplifiée",
    hero_title_1: "Gérez votre flotte et vos locations",
    hero_title_2: "en toute simplicité",
    hero_subtitle: "Logirent centralise vos réservations, vos clients et vos véhicules en une seule plateforme intuitive.",
    hero_cta_primary: "Commencer maintenant",
    hero_cta_secondary: "Voir la démo",
    
    // Stats
    stats_vehicles: "Véhicules gérés",
    stats_reservations: "Réservations",
    stats_clients: "Clients actifs",
    
    // Problem/Solution
    problem_title: "Le problème",
    problem_1: "Gestion manuelle compliquée",
    problem_2: "Perte de temps considérable",
    problem_3: "Manque de visibilité",
    problem_4: "Données dispersées",
    solution_title: "La solution",
    solution_1: "Centralisation complète",
    solution_2: "Automatisation intelligente",
    solution_3: "Suivi en temps réel",
    solution_4: "Dashboard unifié",
    
    // Features
    features_title: "Tout ce dont vous avez besoin",
    features_subtitle: "Une plateforme complète pour gérer votre activité de location",
    feature_reservations: "Gestion des réservations",
    feature_reservations_desc: "Planifiez et suivez toutes vos réservations en un seul endroit.",
    feature_vehicles: "Gestion des véhicules",
    feature_vehicles_desc: "Suivez l'état, la maintenance et la disponibilité de votre flotte.",
    feature_clients: "Gestion clients",
    feature_clients_desc: "Centralisez les informations de vos clients et leur historique.",
    feature_payments: "Paiements intégrés",
    feature_payments_desc: "Acceptez les paiements Stripe et TWINT en toute simplicité.",
    feature_analytics: "Dashboard analytics",
    feature_analytics_desc: "Visualisez vos performances et prenez des décisions éclairées.",
    feature_gps: "Suivi GPS",
    feature_gps_desc: "Localisez vos véhicules en temps réel grâce à Logitrak.",
    
    // Logitrak
    logitrak_badge: "Intégration exclusive",
    logitrak_title: "Connecté à Logitrak",
    logitrak_subtitle: "Géolocalisation intelligente",
    logitrak_desc: "Grâce à Logitrak, suivez vos véhicules en temps réel, analysez les trajets et optimisez votre flotte.",
    logitrak_feature_1: "Localisation en temps réel",
    logitrak_feature_2: "Historique des trajets",
    logitrak_feature_3: "Alertes personnalisées",
    logitrak_cta: "Découvrir Logitrak",
    
    // Advantages
    advantages_title: "Pourquoi choisir Logirent ?",
    advantages_subtitle: "Des avantages concrets pour votre entreprise",
    advantage_time: "Gain de temps",
    advantage_time_desc: "Automatisez vos tâches répétitives et concentrez-vous sur l'essentiel.",
    advantage_cost: "Réduction des coûts",
    advantage_cost_desc: "Optimisez vos ressources et réduisez les coûts opérationnels.",
    advantage_org: "Meilleure organisation",
    advantage_org_desc: "Tout au même endroit, accessible à tout moment.",
    advantage_vision: "Vision temps réel",
    advantage_vision_desc: "Prenez des décisions éclairées avec des données à jour.",
    
    // How it works
    how_title: "Comment ça marche ?",
    how_subtitle: "Démarrez en 3 étapes simples",
    how_step_1: "Créez votre compte",
    how_step_1_desc: "Inscription rapide et configuration guidée de votre espace.",
    how_step_2: "Ajoutez vos véhicules",
    how_step_2_desc: "Importez ou créez votre flotte en quelques clics.",
    how_step_3: "Gérez vos réservations",
    how_step_3_desc: "Commencez à recevoir et gérer vos réservations.",
    
    // CTA
    cta_title: "Prêt à transformer votre gestion de flotte ?",
    cta_subtitle: "Rejoignez des centaines d'entreprises qui font confiance à Logirent.",
    cta_button: "Lancez Logirent aujourd'hui",
    
    // Contact
    contact_title: "Contactez-nous",
    contact_subtitle: "Une question ? Nous sommes là pour vous aider.",
    contact_name: "Votre nom",
    contact_email: "Votre email",
    contact_message: "Votre message",
    contact_send: "Envoyer le message",
    contact_sending: "Envoi en cours...",
    contact_success: "Message envoyé avec succès !",
    contact_error: "Erreur lors de l'envoi. Veuillez réessayer.",
    
    // Pricing
    pricing_title: "Tarifs simples et transparents",
    pricing_subtitle: "Choisissez le plan adapté à votre flotte",
    pricing_starter: "Starter",
    pricing_starter_desc: "Fonctionnalités minimales",
    pricing_starter_price: "Sur demande",
    pricing_pro: "Pro",
    pricing_pro_desc: "Pour les flottes en croissance",
    pricing_pro_price: "Sur demande",
    pricing_enterprise: "Enterprise",
    pricing_enterprise_desc: "Pour les grandes entreprises",
    pricing_enterprise_price: "Sur mesure",
    pricing_per_month: "/mois",
    pricing_vehicles: "véhicules",
    pricing_feature_reservations: "Gestion des réservations",
    pricing_feature_vehicles: "Gestion des véhicules",
    pricing_feature_clients: "Gestion des clients",
    pricing_feature_dashboard: "Dashboard analytics",
    pricing_feature_support_email: "Support email (sous 6h)",
    pricing_feature_support_phone: "Support téléphonique (heures de bureau)",
    pricing_feature_logitrak: "Intégration Logitrak",
    pricing_feature_api: "API personnalisée",
    pricing_feature_dedicated: "Gestionnaire dédié",
    pricing_cta: "Commencer",
    pricing_contact: "Nous contacter",
    pricing_popular: "Populaire",
    
    // Footer
    footer_tagline: "La solution tout-en-un pour la gestion de flotte.",
    footer_links: "Liens utiles",
    footer_about: "À propos",
    footer_legal: "Mentions légales",
    footer_privacy: "Politique de confidentialité",
    footer_contact: "Contact",
    footer_copyright: "Tous droits réservés.",
  },
  en: {
    // Navbar
    nav_features: "Features",
    nav_pricing: "Pricing",
    nav_advantages: "Advantages",
    nav_logitrak: "Logitrak",
    nav_contact: "Contact",
    nav_login: "Login",
    
    // Hero
    hero_badge: "Simplified fleet management",
    hero_title_1: "Manage your fleet and rentals",
    hero_title_2: "with ease",
    hero_subtitle: "Logirent centralizes your reservations, clients, and vehicles in one intuitive platform.",
    hero_cta_primary: "Get started now",
    hero_cta_secondary: "View demo",
    
    // Stats
    stats_vehicles: "Vehicles managed",
    stats_reservations: "Reservations",
    stats_clients: "Active clients",
    
    // Problem/Solution
    problem_title: "The problem",
    problem_1: "Complicated manual management",
    problem_2: "Significant time waste",
    problem_3: "Lack of visibility",
    problem_4: "Scattered data",
    solution_title: "The solution",
    solution_1: "Complete centralization",
    solution_2: "Smart automation",
    solution_3: "Real-time tracking",
    solution_4: "Unified dashboard",
    
    // Features
    features_title: "Everything you need",
    features_subtitle: "A complete platform to manage your rental business",
    feature_reservations: "Reservation management",
    feature_reservations_desc: "Plan and track all your reservations in one place.",
    feature_vehicles: "Vehicle management",
    feature_vehicles_desc: "Track the status, maintenance, and availability of your fleet.",
    feature_clients: "Client management",
    feature_clients_desc: "Centralize your client information and history.",
    feature_payments: "Integrated payments",
    feature_payments_desc: "Accept Stripe and TWINT payments with ease.",
    feature_analytics: "Analytics dashboard",
    feature_analytics_desc: "Visualize your performance and make informed decisions.",
    feature_gps: "GPS tracking",
    feature_gps_desc: "Locate your vehicles in real-time with Logitrak.",
    
    // Logitrak
    logitrak_badge: "Exclusive integration",
    logitrak_title: "Connected to Logitrak",
    logitrak_subtitle: "Intelligent geolocation",
    logitrak_desc: "With Logitrak, track your vehicles in real-time, analyze trips, and optimize your fleet.",
    logitrak_feature_1: "Real-time location",
    logitrak_feature_2: "Trip history",
    logitrak_feature_3: "Custom alerts",
    logitrak_cta: "Discover Logitrak",
    
    // Advantages
    advantages_title: "Why choose Logirent?",
    advantages_subtitle: "Concrete benefits for your business",
    advantage_time: "Time savings",
    advantage_time_desc: "Automate repetitive tasks and focus on what matters.",
    advantage_cost: "Cost reduction",
    advantage_cost_desc: "Optimize your resources and reduce operational costs.",
    advantage_org: "Better organization",
    advantage_org_desc: "Everything in one place, accessible anytime.",
    advantage_vision: "Real-time vision",
    advantage_vision_desc: "Make informed decisions with up-to-date data.",
    
    // How it works
    how_title: "How does it work?",
    how_subtitle: "Get started in 3 simple steps",
    how_step_1: "Create your account",
    how_step_1_desc: "Quick registration and guided setup of your workspace.",
    how_step_2: "Add your vehicles",
    how_step_2_desc: "Import or create your fleet in just a few clicks.",
    how_step_3: "Manage your reservations",
    how_step_3_desc: "Start receiving and managing your reservations.",
    
    // CTA
    cta_title: "Ready to transform your fleet management?",
    cta_subtitle: "Join hundreds of companies that trust Logirent.",
    cta_button: "Launch Logirent today",
    
    // Contact
    contact_title: "Contact us",
    contact_subtitle: "Have a question? We're here to help.",
    contact_name: "Your name",
    contact_email: "Your email",
    contact_message: "Your message",
    contact_send: "Send message",
    contact_sending: "Sending...",
    contact_success: "Message sent successfully!",
    contact_error: "Error sending message. Please try again.",
    
    // Pricing
    pricing_title: "Simple and transparent pricing",
    pricing_subtitle: "Choose the plan that fits your fleet",
    pricing_starter: "Starter",
    pricing_starter_desc: "Minimal features",
    pricing_starter_price: "On request",
    pricing_pro: "Pro",
    pricing_pro_desc: "For growing fleets",
    pricing_pro_price: "On request",
    pricing_enterprise: "Enterprise",
    pricing_enterprise_desc: "For large companies",
    pricing_enterprise_price: "Custom",
    pricing_per_month: "/month",
    pricing_vehicles: "vehicles",
    pricing_feature_reservations: "Reservation management",
    pricing_feature_vehicles: "Vehicle management",
    pricing_feature_clients: "Client management",
    pricing_feature_dashboard: "Analytics dashboard",
    pricing_feature_support_email: "Email support (within 6h)",
    pricing_feature_support_phone: "Phone support (business hours)",
    pricing_feature_logitrak: "Logitrak integration",
    pricing_feature_api: "Custom API",
    pricing_feature_dedicated: "Dedicated manager",
    pricing_cta: "Get started",
    pricing_contact: "Contact us",
    pricing_popular: "Popular",
    
    // Footer
    footer_tagline: "The all-in-one solution for fleet management.",
    footer_links: "Useful links",
    footer_about: "About",
    footer_legal: "Legal notice",
    footer_privacy: "Privacy policy",
    footer_contact: "Contact",
    footer_copyright: "All rights reserved.",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');
  
  const t = (key) => {
    return translations[language][key] || key;
  };
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
